export default __webpack_public_path__ + "static/media/seatchart.678eba82.svg";